import DefaultAvatar from './DefaultAvatar.tsx';

interface AvatarProps {
  username: string;
  avatarFilename?: string | null;
  size?: number;
}

/** Ring width scales linearly with avatar size, clamped to [2, 3] px. */
function ringWidth(size: number): string {
  return `${Math.min(2, Math.max(1, size * 0.04)).toFixed(2)}px`;
}

/** Outline offset scales linearly with avatar size, clamped to [1, 2] px. */
function ringOffset(size: number): string {
  return `${Math.min(2, Math.max(1, size / 36)).toFixed(2)}px`;
}

export default function Avatar({ username, avatarFilename, size = 32 }: AvatarProps) {
  const vars = {
    '--avatar-ring-w': ringWidth(size),
    '--avatar-ring-offset': ringOffset(size),
  } as React.CSSProperties;

  if (avatarFilename) {
    return (
      <img
        src={`/avatars/${avatarFilename}`}
        width={size}
        height={size}
        className="avatar-img"
        style={{ width: size, height: size, ...vars }}
        alt=""
      />
    );
  }
  return (
    <span className="avatar-default" style={vars}>
      <DefaultAvatar username={username} size={size} />
    </span>
  );
}
